import { OrderDirectionOption, PageSizeOption, useGetContractQuery } from '@/graphql/generated'
import { useLocation, useNavigate } from 'react-router'
import { NavTabsProps, NavTabsWithActions, PropertyTopBar } from '../molecules';
import { useEffect, useRef, useState } from 'react';
import { LoadingSpinner } from '../atoms'
import { ContractDetailTemplate } from '../templates'
import { useContractDetailsContext, useErrorHandlerContext, useUserLanguage } from '@/customHooks'
import textsData from '@/textData/ContractDetailTexts.json'
import { pathURL } from '@/components/constants/urls'

export const ContractDetailPage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.tabs : textsData.en.tabs

  const { contract, setContract, setExpensesReport } = useContractDetailsContext()

  const isInitialMount = useRef(true);

  const [selectedTab, setSelectedTab] = useState('1')

  const { open: errorHandle } = useErrorHandlerContext()

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!location.state?.id) {
      navigate(`/${pathURL.USER}`, { replace: true })
    }
  }, [location.state?.id, navigate])

  const {data, error, loading, refetch} = useGetContractQuery({ 
    variables: {
      id: location.state?.id || '',
      expensesFilterInput: {
        contractId: location.state?.id || '',
        page: '1',
        pageSize: PageSizeOption.OneHundred,
        orderDirection: OrderDirectionOption.Desc,
      },
    },
    skip: !location.state?.id
  })

  const tabs: NavTabsProps[] = [
    { id: '1', label: texts.tab1 },
    { id: '2', label: texts.tab2 },
    { id: '8', label: texts.tab8 },
    { id: '3', label: texts.tab3 },
    { id: '4', label: texts.tab4 },
    { id: '5', label: texts.tab5 },
    { id: '6', label: texts.tab6 },
    { id: '7', label: texts.tab7 },
  ]

 useEffect(() => {
    if (data?.contract) {
      setContract(data.contract);
    }
    if (data?.expensesReport) {
      setExpensesReport(data.expensesReport);
    }
  }, [data, setContract, setExpensesReport]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (contract === undefined && !loading) {
      refetch();
    }
  }, [contract, loading, refetch]);

  if (error) errorHandle(error)
  
  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <div className="text-center">
          <LoadingSpinner />
          <p>Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <>
      <PropertyTopBar
        name={data?.contract?.property?.name ?? 'No name available'}
        address={{
          street: data?.contract?.property?.address?.street ?? '',
          buildingNumber: data?.contract?.property?.address?.buildingNumber ?? '',
          addressLine: data?.contract?.property?.address?.addressLine ?? '',
          city: data?.contract?.property?.address?.city?.name ?? '',
          state: data?.contract?.property?.address?.state?.name ?? '',
          country: data?.contract?.property?.address?.country?.name ?? '',
          zipCode: data?.contract?.property?.address?.zipCode ?? '',
        }}
      />
      <div>
        <NavTabsWithActions
          tabs={tabs}
          onClick={setSelectedTab}
          selectedTabId={selectedTab}
        />
      </div>
      <div className="mx-auto mt-6 w-full max-w-[1200px] px-4 md:px-6">
        <ContractDetailTemplate selectedSection={selectedTab} />
      </div>
    </>
  )
}